import React from 'react';
import styled, { keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const float = keyframes`
  0% { transform: translateY(0px); }
  50% { transform: translateY(-10px); }
  100% { transform: translateY(0px); }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 27, 43, 0.7);
  backdrop-filter: blur(12px);
  padding: 1rem;
`;

const PopupContainer = styled.div`
  background: white;
  width: 100%;
  max-width: 500px;
  border-radius: 24px;
  padding: 3rem 2rem;
  text-align: center;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.4);
  animation: ${fadeIn} 0.5s cubic-bezier(0.16, 1, 0.3, 1) forwards;
  position: relative;
  overflow: hidden;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 6px;
    background: linear-gradient(90deg, #182848 0%, #4b6cb7 50%, #4cc9f0 100%);
  }
`;

const IconWrapper = styled.div`
  width: 90px;
  height: 90px;
  margin: 0 auto 1.5rem;
  background: linear-gradient(135deg, #f5f9ff 0%, #e0eaf5 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 10px 20px rgba(75, 108, 183, 0.1);
  animation: ${float} 4s ease-in-out infinite;

  i {
    font-size: 2.5rem;
    background: linear-gradient(135deg, #182848 0%, #4b6cb7 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

const Title = styled.h2`
  font-size: 2rem;
  font-weight: 700;
  color: #0f1b2b;
  margin-bottom: 1rem;
  letter-spacing: -0.5px;
`;

const Description = styled.p`
  font-size: 1.05rem;
  color: #6c757d;
  line-height: 1.6;
  margin-bottom: 2rem;
  padding: 0 1rem;
`;

const ProgressBar = styled.div`
  width: 100%;
  height: 6px;
  background: #f0f2f5;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 1rem;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    width: 40%;
    background: linear-gradient(90deg, #4b6cb7 0%, #4cc9f0 100%);
    border-radius: 10px;
    animation: loading 2s ease-in-out infinite alternate;
  }

  @keyframes loading {
    0% { transform: translateX(-100%); }
    100% { transform: translateX(250%); }
  }
`;

const MaintenancePopup = () => {
    return (
        <Overlay>
            <PopupContainer>
                <IconWrapper>
                    <i className="fa-solid fa-person-digging"></i>
                </IconWrapper>
                <Title>Site Under Maintenance</Title>
                <Description>
                    We are currently performing scheduled maintenance to improve your experience.
                    Please check back shorty. We appreciate your patience!
                </Description>
                <ProgressBar />
            </PopupContainer>
        </Overlay>
    );
};

export default MaintenancePopup;
